'use client';

import { useEffect } from 'react';

export function useFontAwesome() {
  useEffect(() => {
    // Carregar CSS do FontAwesome
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
    document.head.appendChild(link);

    return () => {
      // Limpar o CSS ao desmontar
      document.head.removeChild(link);
    };
  }, []);
} 